import { render, staticRenderFns } from "./BackAndForthNav.vue?vue&type=template&id=3ce1e4de"
import script from "./BackAndForthNav.vue?vue&type=script&lang=ts"
export * from "./BackAndForthNav.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports